import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { CollaborationService } from '../../services/collaboration.service';
import { WeavyData } from '../../interfaces/space.interface';


@Component({
    selector: 'app-basic-reusable-component',
    template: '',
    styleUrls: []
})
export class BasicReusableComponentComponent implements OnInit, OnChanges {
  private _ihubMaximizeFlag!: boolean;
  @Input() weavyData: any;
  @Input()
  set ihubMaximizeFlag(value: boolean) {
    this._ihubMaximizeFlag = value;
    this.collaborationService.maximizeFlag.next(value);
  }

  get ihubMaximizeFlag(): boolean {
    return this._ihubMaximizeFlag;
  }

  @Input()
  set WeavyRefresh(value: boolean) {
    if(value === true) {
      this.refreshWeavy();
    }
  }

  showLoader: boolean = true;
  constructor(public collaborationService: CollaborationService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['weavyData']) {
      this.collaborationService.userEmail = this.weavyData.userEmail ?? this.collaborationService.userEmail;
      this.collaborationService.isMobileScreen = this.weavyData.isMobileScreen ?? this.collaborationService.isMobileScreen;
      delete this.weavyData.token;
      this.initialize();
    }
  }

  initialize() {
  }

  refreshWeavy() {

  }
}
